import script from "./AlertsAcceptedTab.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertsAcceptedTab.vue?vue&type=script&setup=true&lang=js"

import "./AlertsAcceptedTab.vue?vue&type=style&index=0&id=33a467c0&lang=scss"

const __exports__ = script;

export default __exports__